import ConnectedWinLossModule from './ConnectedWinLossModule';

export default ConnectedWinLossModule;
